module.exports = __webpack_public_path__ + "img/parents_buttons.50868320.png";